export default "__VITE_ASSET__DMrtYnmY__"